import ajaxMixins from 'Root/vue/mixins/ajaxMixins'
import Loader from 'Root/vue/components/Loader.vue'
import ResponseError from 'Root/vue/components/ResponseError.vue'

export default {
    components: {
        Loader,
        'response-error': ResponseError,
    },

    mixins: [ajaxMixins],

    data() {
        return {
            loading: false,
            hasError: false,
            errorMessages: '',

            email: '',

            submitted: false,
            success: false,
            responseMsg: '',
        }
    },

    methods: {
        submitForm() {
            if (!$(this.$el).valid()) {
                this.submitted = false
                this.success = false
                this.responseMsg = ''
                return
            }

            const payload = {
                email: this.email,
                locale: this.appData.configuration.locale,
            }

            this.ajax(this.appData.configuration.submitEndpoint, payload, this.showSuccess, this.showError)
        },

        showSuccess() {
            this.submitted = true
            this.success = true
            this.responseMsg = this.appData.dictionary.successMsg
        },

        showError() {
            this.submitted = true
            this.success = false
            this.responseMsg = this.errorMessages
        },
    },
}
